import { action, makeObservable, observable, runInAction } from 'mobx';
import { FormState } from 'formstate';

import { InputFieldState } from '@servicetitan/form-state';
import { inject, injectable } from '@servicetitan/react-ioc';

import { APP_API_TOKEN, IAppApi } from '../../api/app.api';
import { validateEmailAddress, validateUrl } from '../utils';

const validateOrganization = (value: string) => !value.trim() && 'Enter a name.';
const validateDescription = (value: string) => !value.trim() && 'Enter a description.';

@injectable()
export class RequestNewAppPageStore {
    @observable saving = false;
    @observable submitted = false;
    @observable readonly form = new FormState({
        organization: new InputFieldState<string>('')
            .setAutoValidationDefault(false)
            .validators(validateOrganization),
        homepageUrl: new InputFieldState<string>('')
            .setAutoValidationDefault(false)
            .validators(validateUrl),
        emailAddress: new InputFieldState<string>('')
            .setAutoValidationDefault(false)
            .validators(validateEmailAddress),
        description: new InputFieldState<string>('')
            .setAutoValidationDefault(false)
            .validators(validateDescription),
    });

    constructor(@inject(APP_API_TOKEN) private readonly appApi: IAppApi) {
        makeObservable(this);
    }

    @action
    async submit(): Promise<boolean> {
        const result = await this.form.enableAutoValidationAndValidate();
        if (result.hasError) {
            return false;
        }
        runInAction(() => {
            this.saving = true;
        });
        try {
            await this.appApi.requestNewApp({
                organizationName: this.form.$.organization.value,
                organizationUrl: this.form.$.homepageUrl.value,
                contactEmailAddress: this.form.$.emailAddress.value,
                description: this.form.$.description.value,
            });
            runInAction(() => {
                this.submitted = true;
            });
            return true;
        } finally {
            runInAction(() => {
                this.saving = false;
            });
        }
    }
}
